import { render, staticRenderFns } from "./ReferralConfirmSlotModal.vue?vue&type=template&id=6b2c950b&scoped=true"
import script from "./ReferralConfirmSlotModal.vue?vue&type=script&lang=js"
export * from "./ReferralConfirmSlotModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralConfirmSlotModal.vue?vue&type=style&index=0&id=6b2c950b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c950b",
  null
  
)

export default component.exports